import rest from "../script/rest";
import commonUtils from "../script/utils/commonUtils";

class UserRest {

    async getAll() {
        const url = "/rest/user/getAll";
        const response = await rest.get(url);
        return response.json();
    }

    async downloadUserStatsCsv() {
        const url = "/rest/user/downloadUserStatsCsv";
        await commonUtils.download(url);
    }

    async downloadUserListCsv() {
        const url = "/rest/user/downloadUserListCsv";
        await commonUtils.download(url);
    }

    async create(username, email, companyName) {
        const url = "/rest/user/create";
        const formData = new FormData();
        formData.append("username", username);
        formData.append("email", email);
        formData.append("companyName", companyName);
        const response = await rest.form(url, formData);
        return response;
    }

    async setActiveById(userId, active) {
        const url = "/rest/user/setActiveById"
            + "?userId=" + userId
            + "&active=" + active;
        await rest.get(url);
    }

    async resetPasswordById(userId) {
        const url = "/rest/user/resetPasswordById"
            + "?userId=" + userId;
        await rest.get(url);
    }

    async isUsernameUsed(username) {
        const url = "/rest/user/isUsernameUsed"
            + "?username=" + username;
        const response = await rest.get(url);
        const json = await response.json();
        return json.value;
    }

    async changePassword(passwordOld, passwordNew) {
        const url = "/rest/user/updatePassword";
        const body = { passwordOld, passwordNew };
        await rest.post(url, body);
    }

    async checkPassword(password) {
        const url = "/rest/user/checkPassword";
        const body = { password };
        const response = await rest.post(url, body);
        const json = await response.json();
        return json.value;
    }

    async getAuthenticatedUser() {
        const url = "/rest/user/getAuthenticatedUser";
        const response = await rest.get(url);
        return response.json();
    }

    async acceptAgreement() {
        const url = "/rest/user/acceptAgreement";
        await rest.get(url);
    }
}
const userRest = new UserRest();
window.userRest = userRest;
export default userRest;